import React from 'react';
import { useLocation } from 'wouter';

import FhfTransferForm from './fhfForm/TransferForm';

import type { Transfer } from '../../common/types/transfer';

type Props = {
  transfer: Transfer;
  updateTransfer: (transfer: Transfer) => void;
  saveTransfer: (transfer: Transfer) => void;
};

const reactAppVersion = process.env.REACT_APP_VERSION;

function TransferForm(props: Props) {
  const [location] = useLocation();

  if (reactAppVersion === 'dnd') {
    return <></>;
  }
  if (reactAppVersion === 'fb') {
    return <></>;
  }
  if (reactAppVersion === 'fhbf' && location.includes('fachberatungsstelle')) {
    return <></>;
  }
  if (reactAppVersion === 'fhbf' && location.includes('interventionsstelle')) {
    return <></>;
  }
  if (reactAppVersion === 'fhf') {
    return (
      <FhfTransferForm
        transfer={props.transfer}
        updateTransfer={props.updateTransfer}
        saveTransfer={props.saveTransfer}
      />
    );
  }
  return <></>;
}

export default TransferForm;
